import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Patches window.fetch to intercept Auth0 token endpoint responses.
// This is necessary because the Auth0 Angular SDK uses the browser Fetch API
// directly, bypassing Angular's HttpClient interceptors.
@Injectable()
export class FetchInterceptorService {
  private accessTokenSubject = new BehaviorSubject<string | undefined>(undefined);
  readonly accessToken$ = this.accessTokenSubject.asObservable();
  
  constructor(){
  }

  Install(): void {
    localStorage.setItem('raw_access_token', null);
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
      const url = typeof input === 'string'
        ? input
        : input instanceof URL ? input.href : (input as Request).url;

      const response = await originalFetch(input, init);

      if (url.includes('/oauth/token')) {
        response.clone().json().then((body: any) => {
          if (body?.access_token) {
            this.accessTokenSubject.next(body.access_token);            
            localStorage.setItem('raw_access_token', body.access_token);
          }
        }).catch(() => {});
      }

      return response;
    };
  }
}
 

